import React from 'react';

type SvgportfolioProps = React.SVGProps<SVGSVGElement>;

const Svgportfolio: React.FC<SvgportfolioProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_969_11645)">
      <path
        d="M12.0101 0.75C5.80869 0.75 0.757812 5.79787 0.757812 11.9993C0.757812 18.2006 5.80869 23.2481 12.0101 23.2481C18.1567 23.2481 23.1708 18.2771 23.2593 12.0083V11.9985C23.2593 11.5871 22.9207 11.2485 22.5093 11.2485H12.7578V1.49775C12.7562 1.29992 12.677 1.11064 12.5371 0.970745C12.3972 0.830853 12.2079 0.751569 12.0101 0.75ZM11.2593 2.40113V11.9996C11.2602 12.1983 11.3395 12.3886 11.4799 12.5291C11.6204 12.6696 11.8106 12.749 12.0093 12.75H21.6022C21.1357 17.8421 17.0872 21.7496 12.0101 21.7496C6.62056 21.7496 2.25931 17.3888 2.25931 11.9993C2.25931 6.876 6.24031 2.80313 11.2593 2.40113Z"
        fill="#54606F"
      />
      <path
        d="M14.6396 1.08008H14.6328C14.2214 1.08008 13.8828 1.4187 13.8828 1.83008V9.37583C13.8828 9.7872 14.2214 10.1258 14.6328 10.1258H22.1714C22.37 10.1247 22.5601 10.0454 22.7004 9.90494C22.8408 9.76451 22.9201 9.57437 22.9211 9.37583C22.9211 9.30945 22.9121 9.24345 22.8948 9.1797C21.8077 5.16945 18.7214 2.11133 14.8196 1.10445C14.7608 1.08903 14.7003 1.08084 14.6396 1.08008ZM15.3843 3.0942C17.9189 4.06995 19.8761 6.01245 20.9021 8.62433H15.3843V3.0942Z"
        fill="#54606F"
      />
    </g>
    <defs>
      <clipPath id="clip0_969_11645">
        <rect height="24" width="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Svgportfolio;
